import { Component, NgZone, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule, DxTextBoxModule } from "devextreme-angular";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { AppGlobals } from "src/app/app.globals";
import { WikiService } from "src/app/services/wiki.service";
import { DxScrollViewModule } from "devextreme-angular";
import { environment } from "src/environments/environment";
import { ScrollableService } from "src/app/services/misc/scrollable.service";
import { AppConfig } from "src/app/app.config";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { HeaderTab } from "src/app/components/page-nav-bar/page-nav-bar.component";
import { PageNavBarComponent } from "src/app/components/page-nav-bar/page-nav-bar.component";

@Component({
    selector: "app-wiki",
    templateUrl: "./wiki.component.html",
    styleUrls: ["./wiki.component.css", "./wiki.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterModule, DxTextBoxModule, GpdButtonComponent, PageNavBarComponent]
})
export class WikiComponent {
  headerTabs: HeaderTab[] = [
    { id: 1, text: $localize`:@@internal:Internal`, routerLink: "internal" },
    { id: 2, text: $localize`:@@instructionManual:Instruction Manual`, routerLink: "manual" },
  ];

  get path(): string {
    return this.router.url.split('/')[2]?.split('?')[0] || 'internal';
  }

  editPermission: any = "write";
  pageBreadCrumb: any = {
    text: $localize`Wiki/`,
    href: window.location.href,
    layer: 0,
  };

  searchFilter: any;
  backtoTopVisible: boolean = false;

  constructor(
    private appGlobals: AppGlobals,
    private scrollableService: ScrollableService,
    private router: Router
  ) {
    this.scrollableService.scrolled.subscribe((scrollY) => {
      this.backtoTopVisible = scrollY > 300;
    });
  }

  scrollToTop() {
    this.scrollableService.scrollTo(0);
  }

  isMainPage() {
    return this.router.url.split("/").length == 3;
  }

  canEditWiki(): boolean {
    if (this.path == "manual") {
      const email: string = AppGlobals.LoggedInUserData.email;
      if (
        !(
          (email.includes("@tdc.co.za") || email.includes("@gp-digital.io")) &&
          environment.production &&
          AppGlobals.TenantId == AppConfig.sharedWikiTenantId
        )
      ) {
        return false;
      }
    }
    return AppGlobals.UserPermissions.canEdit === true;
  }
}
